import { useLingui } from "@lingui/react";
import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery } from "react-query";
import { UseQueryOptions } from "react-query/types/react/types";

const KEY_POLOTNO_STICKER = "polotno.sticker";

export const useQueryPolotnoSticker = (
  id?: number,
  options?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpArtGallery.Polotno.sticker>>>,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    i18n: { locale },
  } = useLingui();

  const params = {
    id: id || 0,
    text_lang: locale,
  };

  return useQuery<Await<ReturnType<typeof ApiSmpArtGallery.Polotno.sticker>>>(
    [KEY_POLOTNO_STICKER, params],
    () => ApiSmpArtGallery.Polotno.sticker(params),
    {
      ...options,
      enabled: !!params.id && options?.enabled,
    },
  );
};

useQueryPolotnoSticker.KEY = KEY_POLOTNO_STICKER;
